import { Pipe, PipeTransform } from '@angular/core';
import { tokenQuery } from 'src/app/ricerca/interfaces/search-token-req.model';

@Pipe({
  name: 'underlineTokens'
})
export class UnderlineTokensPipe implements PipeTransform {

  transform(occurrence: string, tokens: tokenQuery[]): string {
    let tempTokens = [...tokens];
    tempTokens.sort((a, b) => {
      if(a.token.length > b.token.length) {
        return -1;
      } else if(a.token.length < b.token.length) {
        return 1;
      } else {
        return 0;
      }
    });
    // console.log(tempTokens);
    tempTokens.forEach(t => {
      // occurrence = occurrence.replace(new RegExp('(?<!\\w)' + t + '\\b', "gi"), match => {
        occurrence = occurrence.replace(new RegExp('\\b' + t.token + '\\b', "gi"), match => {
          return '<span class="search-token">' + match + '</span>'
      })
    })
    return occurrence;
  }

}
